let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g6c6a")).then(() => parcelRequire('hcmRy'));